// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Orchestrator.css - Styled Consistently */

/* Container */
.orchestrator-container {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: flex-start;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  max-width: 800px;
  width: 100%;
  margin: 10px auto; /* Center horizontally */
}


.tree-view {
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tree-item {
  margin: 8px 0;
}

.tree-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.tree-item-header:hover {
  background-color: #f5f5f5;
}

.nested {
  margin-left: 24px;
}

.icon {
  color: #305e7a;
}

.tree-item-content {
  margin-left: 32px;
  padding: 8px;
  border-left: 2px solid #e0e0e0;
}

.section {
  margin: 2px 0;
}

.section h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #305e7a;
  margin-bottom: 8px;
}

.item {
  padding: 4px 8px;
  margin: 4px 0;
  border-radius: 4px;
  background-color: #f5f5f5;
}

.orchestrator-container {
  padding: 20px;
}

.orchestrator-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.section {
  min-height: 300px;
  margin-bottom: 20px;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Add these new styles */
.bottom-sections {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.section h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0px;
  color: #333;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.item {
  padding: 10px;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid #eee;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.item:hover {
  background: #e0e0e0;
}

.item.selected {
  background: #356583;
  color: white;
}

.empty-state {
  justify-content: center;
  color: #666;
  font-style: italic;
  background: #f5f5f5;
  height: 40px;
}


`, "",{"version":3,"sources":["webpack://./src/styles/Orchestrator.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,WAAW;EACX,iBAAiB,EAAE,wBAAwB;AAC7C;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["/* Orchestrator.css - Styled Consistently */\n\n/* Container */\n.orchestrator-container {\n  display: flex;\n  flex-direction: column;\n  /* align-items: center; */\n  justify-content: flex-start;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n  max-width: 800px;\n  width: 100%;\n  margin: 10px auto; /* Center horizontally */\n}\n\n\n.tree-view {\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tree-item {\n  margin: 8px 0;\n}\n\n.tree-item-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.tree-item-header:hover {\n  background-color: #f5f5f5;\n}\n\n.nested {\n  margin-left: 24px;\n}\n\n.icon {\n  color: #305e7a;\n}\n\n.tree-item-content {\n  margin-left: 32px;\n  padding: 8px;\n  border-left: 2px solid #e0e0e0;\n}\n\n.section {\n  margin: 2px 0;\n}\n\n.section h4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #305e7a;\n  margin-bottom: 8px;\n}\n\n.item {\n  padding: 4px 8px;\n  margin: 4px 0;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n}\n\n.orchestrator-container {\n  padding: 20px;\n}\n\n.orchestrator-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.section {\n  min-height: 300px;\n  margin-bottom: 20px;\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n/* Add these new styles */\n.bottom-sections {\n  grid-column: 1 / -1;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.section h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 0px;\n  color: #333;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 300px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.item {\n  padding: 10px;\n  border-radius: 4px;\n  background: #f5f5f5;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-bottom: 1px solid #eee;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n\n.item:hover {\n  background: #e0e0e0;\n}\n\n.item.selected {\n  background: #356583;\n  color: white;\n}\n\n.empty-state {\n  justify-content: center;\n  color: #666;\n  font-style: italic;\n  background: #f5f5f5;\n  height: 40px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
